import * as React from 'react';
import Guidance from '../../../../../../models/data/Guidance';
import CouponGuidance from '../../../../../../models/data/CouponGuidance';
import PriceGuidance from '../../../../../../models/data/PriceGuidance';
import SpreadGuidance from '../../../../../../models/data/SpreadGuidance';
import PopupButtons from '../PopupButtons';
import PriceGuidanceEditor from './PriceGuidanceEditor';
import SpreadGuidanceEditor from './SpreadGuidanceEditor';
import YieldGuidanceEditor from './YieldGuidanceEditor';
import BasisSwitch from './BasisSwitch';
import CouponGuidanceEditor from './CouponGuidanceEditor';
import './Guidance.css';
const GuidanceEditor = ({ data, initialGuidance, hasOverride, save }) => {
    const [basis, setBasis] = React.useState(data?.basis() ?? 'spread');
    const [guidance, setGuidance] = React.useState(() => {
        const initialBasis = data?.basis();
        console.log("INIT : %o", initialBasis);
        const initialBenchmark = data?.benchmark();
        if (initialGuidance === undefined && (initialBasis === undefined || initialBasis === 'spread') && initialBenchmark !== undefined) {
            const newSpreadGuidance = new SpreadGuidance({ benchmark: initialBenchmark });
            return new Guidance({ spread: newSpreadGuidance });
        }
        return initialGuidance;
    });
    const onChangeSpreadGuidance = React.useCallback((event) => {
        setGuidance(new Guidance({ spread: event.target.value }));
    }, [setGuidance]);
    const onChangeCouponGuidance = React.useCallback((event) => {
        setGuidance(current => {
            const currentPrice = current?.price;
            return new Guidance({
                coupon: event.target.value,
                price: currentPrice !== undefined ? new PriceGuidance(currentPrice) : undefined
            });
        });
        setGuidance(new Guidance({ coupon: event.target.value }));
    }, [setGuidance]);
    const onChangePriceGuidance = React.useCallback((event) => {
        setGuidance(current => {
            const currentCoupon = current?.coupon;
            return new Guidance({
                coupon: currentCoupon !== undefined ? new CouponGuidance(currentCoupon) : undefined,
                price: event.target.value
            });
        });
    }, [setGuidance]);
    const onChangeYieldGuidance = React.useCallback((event) => {
        setGuidance(new Guidance({ yield: event.target.value }));
    }, [setGuidance]);
    console.log("BASIS: %o", basis);
    const content = React.useMemo(() => {
        switch (basis) {
            case 'spread':
                return (React.createElement("div", { className: 'co-guidance' },
                    React.createElement(SpreadGuidanceEditor, { value: guidance?.spread, onChange: onChangeSpreadGuidance })));
            case 'yield':
                return (React.createElement("div", { className: 'co-guidance' },
                    React.createElement(YieldGuidanceEditor, { value: guidance?.yield, onChange: onChangeYieldGuidance })));
            case 'coupon':
            case 'price':
            case 'priceCoupon':
                return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                    React.createElement("div", { className: 'co-guidance' },
                        React.createElement(PriceGuidanceEditor, { value: guidance?.price, onChange: onChangePriceGuidance })),
                    React.createElement("div", { className: 'co-guidance' },
                        React.createElement(CouponGuidanceEditor, { value: guidance?.coupon, onChange: onChangeCouponGuidance }))));
            default:
                return undefined;
        }
    }, [basis, guidance?.coupon, guidance?.price, guidance?.spread, guidance?.yield, onChangeCouponGuidance, onChangePriceGuidance, onChangeSpreadGuidance, onChangeYieldGuidance]);
    return (React.createElement(React.Fragment, null,
        React.createElement(BasisSwitch, { basis: basis, setBasis: setBasis }),
        content,
        React.createElement("div", { style: { display: 'flex', justifyContent: 'right', marginTop: '0.5rem' } },
            React.createElement(PopupButtons, { hasOverride: hasOverride, save: save, isDisabled: false, value: guidance }))));
};
export default GuidanceEditor;
